import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/throw';

import * as forge from 'assets/forge.min';

import { Headers, Http, Response, URLSearchParams } from '@angular/http';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import { User } from '../models/user.model';
import { environment } from '../../../environments/environment';

import { NotifierMessageType } from '../notifier/notifier.model';
import { NotifierService } from '../notifier/notifier.service';

@Injectable()
export class AuthenticationService {
    private jwtHelper: JwtHelper = new JwtHelper();
    private itemkey = 'sf.token';
    public loginNotifier: BehaviorSubject<boolean>;

    constructor(private http: Http,
        private notifierService: NotifierService) {
        this.loginNotifier = new BehaviorSubject<boolean>(false);
        this.loginNotifier.next(this.isLoggedIn);
    }

    getEncriptedPassword(password: string): Observable<{}> {
        if (!this.useEncription) {
            return Observable.of({ password: password, encrypted: false });
        }

        const headers = new Headers({ 'Content-Type': 'application/json' });
        return this.http.get(`${environment.apiBaseUrl}/auth/key`, { headers: headers })
            .map((response: Response) => {

                let isEncrypted = false;
                let passwordToSend = password;
                const publickey = response.json() && response.json().public_key;
                if (publickey) {
                    const pki = forge.pki;
                    const decodedPublicKey = forge.util.decode64(publickey);
                    const forgePublicKey = pki.publicKeyFromPem(decodedPublicKey);
                    const utf8Password = forge.util.encodeUtf8(password);
                    const encrypted = forgePublicKey.encrypt(utf8Password);
                    passwordToSend = forge.util.encode64(encrypted);
                    isEncrypted = true;
                }
                const result = { password: passwordToSend, encrypted: isEncrypted };
                return result;
            })
            .catch(error => {
                const result = { password: password, encrypted: false };
                return Observable.of(result);
            });
    }

    login(username: string, password: string): Observable<boolean> {
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.append('username', encodeURIComponent(username.trim()));
        urlSearchParams.append('password', encodeURIComponent(password.trim()));
        urlSearchParams.append('grant_type', encodeURIComponent('password'));
        const body = urlSearchParams.toString();

        return this.http.post(`${environment.apiBaseUrl}/auth/login`, body, { headers: headers })
            .map(
                (response: Response) => {
                    // login successful if there's a jwt token in the response
                    const token = response.json() && response.json().access_token;
                    if (token) {
                        // store the jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem(this.itemkey, token);
                    }

                    const loggedIn = this.isLoggedIn;
                    this.loginNotifier.next(loggedIn);
                    return loggedIn;
                }).catch(error => {
                    const loggedIn = this.isLoggedIn;
                    this.loginNotifier.next(loggedIn);
                    this.notifierService.activateSimple(NotifierMessageType.Error, error._body);

                    return Observable.of(loggedIn);
                });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        localStorage.removeItem(this.itemkey);
        this.loginNotifier.next(false);
    }

    get authHeader(): String {
        const token = localStorage.getItem(this.itemkey);
        if (token === null) {
            return '';
        }
        return `Bearer ${token}`;
    }

    get isLoggedIn(): boolean {
        return this.isTokenValid();
    }

    private isTokenValid(): boolean {
        const token = localStorage.getItem(this.itemkey);
        if (token === null) {
            return false;
        }
        const jwtHelper = new JwtHelper();
        return !jwtHelper.isTokenExpired(token);
    }

    private get useEncription(): boolean {
        return environment.useEncription;
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/authentication.service.ts